<template>
<div>
  <page-title value="午睡チェック"></page-title>
  <date-pager class="pt-4"></date-pager>

  <table class="time_table">
    <tr>
      <td v-for="n in 12" @click="selectedHour = (n - 1)" :key="n">{{ n - 1 }}</td>
    </tr>
    <tr>
      <td v-for="n in 12" @click="selectedHour = (n + 11)" :key="n">{{ n + 11 }}</td>
    </tr>
    <tr>
      <td v-for="item in minutesList" :key="item">{{ selectedHour + ':' + item }}</td>
    </tr>
  </table>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import DatePager from '@/components/atoms/DatePager.vue';

export default defineComponent({
  name: 'NapCheck',

  components: {
    PageTitle,
    DatePager,
  },

  data() {
    return {
      selectedHour: 12 as number,
      minutesList: ['00','05','10','15','20','25','30','35','40','45','50','55'],
    }
  },
})
</script>

<style scoped>

.time_table td:hover {
  background-color: grey;
  color: white;
}
</style>